const CONVERSION_RATES = {
  CM_PER_INCH: 2.54,
  LTR_PER_GAL: 3.78541,
  M_PER_FT: 0.3048,
  KG_PER_LBS: 0.453592,
};

const UNITS = {
  CM: 'cm',
  INCH: 'in',
  GAL: 'gal',
  LTR: 'ltr',
  FOOT: "'",
  METER: 'm',
  KG: 'kg',
  LBS: 'lbs',
  LB: 'lb',
};

const UNIT_TEXT = {
  US_STANDARD: 'US Standard',
  METRIC: 'Metric',
};

const SPECIAL_CASES = {
  UP_TO: 'up to',
  AND_UP: 'and up',
};

const COOKIE_NAME = 'pformUnits';
const COUNTRY_COOKIE_NAME = 'countryCodeZmap';
const US_STANDARD_COUNTRIES = ['us', 'lr', 'mm'];

function getCookiesInstance() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (window.Cookies) {
    return window.Cookies;
  }

  if (globalThis.CookiesConstructor) {
    return new globalThis.CookiesConstructor();
  }

  return null;
}

/**
 * Converts units in product specification tables between US Standard and Metric
 */
class PolyformUnitConverter {
  constructor(tableIdentifier) {
    this.tableIdentifier = tableIdentifier;
    this.vertical = false;
    this.cookies = getCookiesInstance();
    this.data = [];
    this.cellMetadata = [];
    this.originalTable = [];
    this.header = [];
    this.columnOne = [];
  }

  setVertical(boolVal) {
    this.vertical = boolVal;
  }

  /**
   * Resolve the Cookies instance lazily. `assets/Cookies.js` may not have
   * executed yet when this converter is constructed at module load, so retry
   * until it is available and cache the result once found.
   */
  getCookies() {
    if (!this.cookies) {
      this.cookies = getCookiesInstance();
    }
    return this.cookies;
  }

  init() {
    this.readTable();
    this.originalTable = JSON.parse(JSON.stringify(this.data));

    const buttonHtml = `
      <div class='right' id='table-unit-convert'>
        <button id='english' class='btn btn--primary spaced'>${UNIT_TEXT.US_STANDARD}</button>
        <button id='metric' class='btn btn--primary spaced'>${UNIT_TEXT.METRIC}</button>
      </div>
    `;

    const tableElement = document.querySelector(this.tableIdentifier);
    tableElement.insertAdjacentHTML('beforeend', buttonHtml);

    // Use arrow functions to avoid bind
    document
      .getElementById('english')
      .addEventListener('click', () => this.setEnglish());
    document
      .getElementById('metric')
      .addEventListener('click', () => this.setMetric());
  }

  readTable() {
    this.data = [];
    this.cellMetadata = [];
    this.columnOne = [];

    const rows = document.querySelectorAll(`${this.tableIdentifier} table tr`);

    if (!this.vertical) {
      // Horizontal table: read headers from <th> elements
      const headerCells = document.querySelectorAll(
        `${this.tableIdentifier} table tr th`
      );
      this.header = Array.from(headerCells).map((cell) => cell.textContent);

      // Read data rows (only rows with td elements)
      let dataRowIndex = 0;
      rows.forEach((row) => {
        const cells = row.querySelectorAll('td');

        // Only process rows that have td elements (skip header row)
        if (cells.length > 0) {
          this.data[dataRowIndex] = [];
          this.cellMetadata[dataRowIndex] = [];

          cells.forEach((cell, cellIndex) => {
            if (cellIndex === 0) {
              this.columnOne.push(cell.textContent.trim());
            } else {
              const cellData = this.getCellData(cell);
              this.data[dataRowIndex][cellIndex - 1] = cellData;
              this.cellMetadata[dataRowIndex][cellIndex - 1] = cellData;
            }
          });

          dataRowIndex++;
        }
      });
    } else {
      // Vertical table: each row is a different attribute
      rows.forEach((row, rowIndex) => {
        this.data[rowIndex] = [];
        this.cellMetadata[rowIndex] = [];
        const cells = row.querySelectorAll('td');

        cells.forEach((cell, cellIndex) => {
          if (cellIndex > 0) {
            const cellData = this.getCellData(cell);
            this.data[rowIndex][cellIndex - 1] = cellData;
            this.cellMetadata[rowIndex][cellIndex - 1] = cellData;
          }
        });
      });
    }
  }

  getCellData(cell) {
    const value = cell.textContent.trim();
    const html = cell.innerHTML.trim();
    const isHtml = cell.children.length > 0 || html !== value;

    return {
      value,
      html: isHtml ? html : value,
      isHtml,
    };
  }

  getFirstTDText() {
    const data = [];

    // Select the table by its identifier
    const table = document.querySelector(this.tableIdentifier);

    if (!table) return data; // If the table doesn't exist, return an empty array

    // Get all rows of the table
    const rows = table.querySelectorAll('tbody tr');

    rows.forEach((row) => {
      const firstTD = row.querySelector('td');
      if (firstTD) {
        data.push(firstTD.textContent.trim());
      }
    });

    return data;
  }

  writeTableData(sourceData) {
    const rows = document.querySelectorAll(`${this.tableIdentifier} table tr`);

    let dataRowIndex = 0;
    rows.forEach((row) => {
      const cells = row.querySelectorAll('td');

      // Only process rows with td elements (skip header rows)
      if (cells.length > 0) {
        let dataCellIndex = 0;
        cells.forEach((cell, cellIndex) => {
          if (cellIndex === 0) return; // Skip first column (labels)

          const cellData = sourceData[dataRowIndex]?.[dataCellIndex];

          if (cellData?.isHtml) {
            cell.innerHTML = cellData.html;
          } else if (cellData && typeof cellData.value === 'string') {
            cell.textContent = cellData.value;
          } else {
            cell.textContent = '';
          }

          dataCellIndex++;
        });

        dataRowIndex++;
      }
    });
  }

  writeTable() {
    this.writeTableData(this.data);
  }

  writeOriginalTable() {
    this.writeTableData(this.originalTable);
  }

  rotateTable() {
    const arrayColumn = (arr, n) => arr.map((x) => x[n]);
    let out = "<div class='pform-info-table'><table>";
    out += '<tr>';
    out += `<th>${this.header[0]}</th>`;
    for (let i = 0; i < this.columnOne.length; i++) {
      out += `<th>${this.columnOne[i]}</th>`;
    }
    out += '</tr>';

    for (let i = 1; i < this.header.length; i++) {
      out += '<tr>';
      out += `<td class='first-column'>${this.header[i]}</td>`;
      const col = arrayColumn(this.data, i - 1);
      for (let ii = 0; ii < col.length; ii++) {
        const cellData = col[ii];
        const cellValue = cellData?.isHtml
          ? cellData.html
          : (cellData?.value ?? '');
        out += `<td class='first-column'>${cellValue}</td>`;
      }
      out += '</tr>';
    }

    return `${out}</table></div>`;
  }

  convertSize(value) {
    const [diam, , len, units] = value.split(' ');
    const diamValue = this.parseNumber(diam);
    const lenValue = this.parseNumber(len);

    if (units?.substring(0, 2).toLowerCase() === UNITS.INCH) {
      const convertedDiam =
        Math.round(CONVERSION_RATES.CM_PER_INCH * diamValue * 10) / 10;
      const convertedLen =
        Math.round(CONVERSION_RATES.CM_PER_INCH * lenValue * 10) / 10;
      return `${convertedDiam} x ${convertedLen} ${UNITS.CM}`;
    }

    return `${diamValue} x ${lenValue} ${units}`;
  }

  checkSize(value) {
    return value.split('x').length === 2;
  }

  checkLengthShort(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 2);
    return units === UNITS.INCH || units === UNITS.CM;
  }

  convertLengthShort(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 2);
    let length = this.parseNumber(parts[0]);

    if (units === UNITS.INCH) {
      length = Math.round(CONVERSION_RATES.CM_PER_INCH * length * 10) / 10;
      return `${length} ${UNITS.CM}`;
    }

    return `${length} ${units}`;
  }

  checkVolume(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    return units === UNITS.GAL || units === UNITS.LTR;
  }

  convertVolume(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    let volume = parseFloat(parts[0]);

    if (units === UNITS.GAL) {
      volume = Math.round(CONVERSION_RATES.LTR_PER_GAL * volume * 10) / 10;
      return `${volume} ${UNITS.LTR}`;
    }

    return `${volume} ${units}`;
  }

  checkWeightLbs(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    return units === UNITS.KG || units === UNITS.LBS;
  }

  convertWeightLbs(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    let weight = parseFloat(parts[0]);

    if (units === UNITS.LBS) {
      weight = Math.round(CONVERSION_RATES.KG_PER_LBS * weight * 10) / 10;
      return `${weight} ${UNITS.KG}`;
    }

    return `${weight} ${units}`;
  }

  checkWeight(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    return units === UNITS.KG || units === UNITS.LB;
  }

  convertWeight(value) {
    const parts = value.split(' ');
    const units = parts[parts.length - 1].toLowerCase().substring(0, 3);
    let weight = parseFloat(parts[0]);

    if (units === UNITS.LB) {
      weight = Math.round(CONVERSION_RATES.KG_PER_LBS * weight * 10) / 10;
      return `${weight} ${UNITS.KG}`;
    }

    return `${weight} ${units}`;
  }
  checkBoatSize(value) {
    const lower = value.toLowerCase();
    const hyphenParts = value.split('-');
    const spaceParts = value.split(' ');

    // Check various patterns for foot notation
    return (
      lower.endsWith(UNITS.FOOT) ||
      hyphenParts[0]?.toLowerCase().endsWith(UNITS.FOOT) ||
      spaceParts[0]?.toLowerCase().endsWith(UNITS.FOOT)
    );
  }

  convertBoatSize(value) {
    const lower = value.toLowerCase();

    // Handle "up to X'" case
    if (lower.startsWith(SPECIAL_CASES.UP_TO)) {
      return this.convertUpTo(lower);
    }

    // Handle "X' and up" case
    if (lower.trim().endsWith(SPECIAL_CASES.AND_UP)) {
      return this.convertAndUp(lower);
    }

    // Handle range "X' - Y'" case
    const parts = lower.split('-');
    const val1 = this.convertFootToMeter(parts[0]);
    const val2 = this.convertFootToMeter(parts[1]);
    return `${val1} - ${val2}`;
  }

  convertFootToMeter(value) {
    const unit = value.charAt(value.length - 1);
    const numStr = value.substring(0, value.length - 1).trim();
    let length = this.parseNumber(numStr);

    if (unit === UNITS.FOOT) {
      length = Math.round(10 * CONVERSION_RATES.M_PER_FT * length) / 10;
      return `${length} ${UNITS.METER}`;
    }

    return `${length} ${unit}`;
  }

  convertUpTo(value) {
    const parts = value.split(' ');
    const lastPart = parts[parts.length - 1];

    // Handle cases where meter is already converted
    if (lastPart === UNITS.METER) {
      parts[parts.length - 1] = parts[parts.length - 2] + UNITS.METER;
    }

    const converted = this.convertFootToMeter(parts[parts.length - 1]);
    return `${SPECIAL_CASES.UP_TO} ${converted}`;
  }

  convertAndUp(value) {
    const parts = value.split(' ');
    const converted = this.convertFootToMeter(parts[0]);
    return `${converted} ${SPECIAL_CASES.AND_UP}`;
  }

  parseNumber(value) {
    // Handle fractions like "1/2"
    if (value.includes('/')) {
      const [numerator, denominator] = value.split('/');
      return parseFloat(numerator) / parseFloat(denominator);
    }
    return parseFloat(value);
  }
  convert() {
    const startRow = this.vertical ? 1 : 0;

    for (let i = startRow; i < this.data.length; i++) {
      for (let j = 0; j < this.data[i].length; j++) {
        const cellData = this.data[i][j];

        if (!cellData || cellData.isHtml) {
          continue;
        }

        const value = cellData.value;

        if (typeof value !== 'string' || value.length === 0) {
          continue;
        }

        // Apply conversions based on value format
        if (this.checkSize(value)) {
          const converted = this.convertSize(value);
          cellData.value = converted;
          cellData.html = converted;
        } else if (this.checkLengthShort(value)) {
          const converted = this.convertLengthShort(value);
          cellData.value = converted;
          cellData.html = converted;
        } else if (this.checkVolume(value)) {
          const converted = this.convertVolume(value);
          cellData.value = converted;
          cellData.html = converted;
        } else if (this.checkBoatSize(value)) {
          const converted = this.convertBoatSize(value);
          cellData.value = converted;
          cellData.html = converted;
        } else if (this.checkWeight(value)) {
          const converted = this.convertWeight(value);
          cellData.value = converted;
          cellData.html = converted;
        }
      }
    }

    this.writeTable();
  }

  setEnglish() {
    this.writeOriginalTable();
    this.getCookies()?.setItem(COOKIE_NAME, UNIT_TEXT.US_STANDARD);
  }

  setMetric() {
    this.convert();
    this.getCookies()?.setItem(COOKIE_NAME, UNIT_TEXT.METRIC);
  }

  async setUnitsByCookieOrCountry() {
    const cookies = this.getCookies();

    // Cookies library not yet available — leave the table in its default
    // (US Standard) state rather than throwing.
    if (!cookies) {
      return;
    }

    const cookieUnits = cookies.getItem(COOKIE_NAME);

    if (cookieUnits === UNIT_TEXT.METRIC) {
      this.setMetric();
      return;
    }

    // Check country code to set default units
    const countryCode = cookies.getItem(COUNTRY_COOKIE_NAME);

    if (
      countryCode &&
      typeof countryCode === 'string' &&
      countryCode.length === 2
    ) {
      if (!US_STANDARD_COUNTRIES.includes(countryCode.toLowerCase())) {
        this.setMetric();
      }
    }
  }
  // Function to find the greatest common divisor
}

/**
 * Initialize unit converters for tables on the page
 */
function initializeConverters() {
  // Horizontal tables
  const horizontalTables = document.getElementsByClassName('en-std');
  if (horizontalTables.length > 0) {
    const converter = new PolyformUnitConverter('.en-std');
    converter.init(); // MUST read table first
    converter.setUnitsByCookieOrCountry(); // Then optionally convert
  }

  // Vertical tables
  const verticalTables = document.getElementsByClassName('en-std2');
  if (verticalTables.length > 0) {
    const converter = new PolyformUnitConverter('.en-std2');
    converter.setVertical(true);
    converter.init(); // MUST read table first
    converter.setUnitsByCookieOrCountry(); // Then optionally convert
  }
}

if (typeof document !== 'undefined') {
  initializeConverters();
}

export { PolyformUnitConverter, initializeConverters };
